import { render, staticRenderFns } from "./Town.vue?vue&type=template&id=0b365b22&"
import script from "./Town.vue?vue&type=script&lang=js&"
export * from "./Town.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports